import React from 'react';
import { FaEnvelope } from 'react-icons/fa';
import { FaInstagram, FaPhone, FaWhatsapp } from 'react-icons/fa6';
import logo from '../images/logo.png';
import style from '../css/Footer.module.css';
import { Link } from 'react-router-dom';

function Footer() {
	return (
		<div className={style.container}>
			<div className={style.text_box}>
				<h1>Home-Tech Repairs</h1>
				<p>
					medarahalli village opp to vinayaka layout chikkabanvara Bangalore
					560090
				</p>

				<p>---</p>
				<p>Dhansar pool, jharia road , Dhanbad Jharkhand 828106</p>
				<Link to="tel:+919036874408" className={style.text_rows}>
					<FaPhone color="white" size={20} />
					<p>+91 9036874408</p>
				</Link>
				<Link
					to={'mailto: support@hometechrepairs.com'}
					className={style.text_rows}
				>
					<FaEnvelope color="white" size={20} />
					<p>support@hometechrepairs.com</p>
				</Link>

				<div className={style.text_rows}>
					<Link
						target="_blank"
						to={
							'https://www.instagram.com/hometech__repairs?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=='
						}
					>
						<FaInstagram size={25} color="white" />
					</Link>

					<Link target="_blank" to={'https://wa.me/919036874408'}>
						<FaWhatsapp size={25} color="white" />
					</Link>
				</div>
			</div>

			<div className={style.row}>
				<p style={{ textAlign: 'center' }}>
					© 2025 HomeTech Repairs. <br />
					All rights reserved.
				</p>
				<img src={logo} alt="" className={style.image} />
				<p>Powered by MS Tech Solutions</p>
			</div>
		</div>
	);
}

export default Footer;
